export default __webpack_public_path__ + "static/media/visa.b1d9d299.svg";